var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1851 12.1518C51.4881 7.8321 57.7823 7.74138 61.2667 11.2393C64.7576 14.7438 64.6636 21.0775 60.3577 25.4002L53.0862 32.6999C52.2093 33.5803 52.212 35.0049 53.0924 35.8819C53.9728 36.7588 55.3974 36.7561 56.2744 35.8757L63.5459 28.576C69.2797 22.8198 69.9996 13.6298 64.4548 8.06349C58.9034 2.49053 49.7338 3.21687 43.997 8.97596L29.454 23.5753C23.7201 29.3315 23.0003 38.5216 28.5451 44.0879C29.422 44.9683 30.8467 44.971 31.727 44.0941C32.6074 43.2171 32.6102 41.7925 31.7332 40.9121C28.2423 37.4076 28.3363 31.0737 32.6422 26.7511L47.1851 12.1518Z",
    fill: "#0066CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4548 28.9121C42.5778 28.0317 41.1532 28.029 40.2728 28.9059C39.3924 29.7829 39.3897 31.2075 40.2667 32.0879C43.7576 35.5924 43.6636 41.9261 39.3577 46.2487L24.8148 60.8482C20.5119 65.1679 14.2176 65.2586 10.7332 61.7607C7.24224 58.2562 7.33627 51.9223 11.6422 47.5997L18.9137 40.2999C19.7907 39.4196 19.7879 37.9949 18.9075 37.118C18.0272 36.241 16.6025 36.2437 15.7256 37.1241L8.45404 44.4239C2.72014 50.18 2.00026 59.3701 7.54509 64.9365C13.0965 70.5095 22.2662 69.7831 28.003 64.024L42.5459 49.4245C48.2798 43.6684 48.9996 34.4785 43.4548 28.9121Z",
    fill: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.0a222551681fa98444e6f46b8eceff96.svg";
export { ForwardRef as ReactComponent };